/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Post_DeletedInputs */

const en_msg_post_deleted = /** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post deleted`)
};

const es_msg_post_deleted = /** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación eliminada`)
};

const fr_msg_post_deleted = /** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article supprimé`)
};

const de_msg_post_deleted = /** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag gelöscht`)
};

const id_msg_post_deleted = /** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postingan dihapus`)
};

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const ja_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const zh_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const ar_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const it_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const ru_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const pt_msg_post_deleted = en_msg_post_deleted;

/** @type {(inputs: Msg_Post_DeletedInputs) => LocalizedString} */
const ko_msg_post_deleted = en_msg_post_deleted;

/**
* | output |
* | --- |
* | "Post deleted" |
*
* @param {Msg_Post_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_post_deleted = /** @type {((inputs?: Msg_Post_DeletedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Post_DeletedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_post_deleted(inputs)
	if (locale === "es") return es_msg_post_deleted(inputs)
	if (locale === "fr") return fr_msg_post_deleted(inputs)
	if (locale === "de") return de_msg_post_deleted(inputs)
	if (locale === "ja") return ja_msg_post_deleted(inputs)
	if (locale === "zh") return zh_msg_post_deleted(inputs)
	if (locale === "ar") return ar_msg_post_deleted(inputs)
	if (locale === "id") return id_msg_post_deleted(inputs)
	if (locale === "it") return it_msg_post_deleted(inputs)
	if (locale === "ru") return ru_msg_post_deleted(inputs)
	if (locale === "pt") return pt_msg_post_deleted(inputs)
	return ko_msg_post_deleted(inputs)
});